import React, { useState, useEffect } from 'react';
import { Collapse, Spin } from 'antd';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';

const { Panel } = Collapse;

const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const response = await api.get('/faqs');
      if (response.data.success) {
        setFaqs(response.data.data);
        // Extract unique categories
        const uniqueCategories = [...new Set(response.data.data.map(faq => faq.category))];
        setCategories(uniqueCategories);
      }
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredFaqs = activeCategory === 'all' 
    ? faqs 
    : faqs.filter(faq => faq.category === activeCategory);

  return (
    <div className="home-page">
      <Helmet>
        <title>FAQs - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
    
      {/* ================================================
          BREADCRUMB
      ================================================= */}
     <section
  style={{
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    padding: '40px 0',
    color: '#fff'
  }}
>
  <div className="container text-center">

    <h1
      style={{
        fontSize: 42,
        fontWeight: 700,
        marginBottom: 18,
             color:'#fff'
      }}
    >
  Frequently Asked Questions
    </h1>

    <p
      style={{
        fontSize: 19,
        opacity: 0.9,
        maxWidth: 850,
        margin: '0 auto 15px',
        lineHeight: 1.7
      }}
    >
    Find quick answers about our plans, pricing, features, billing, and everything you need to know before choosing the right plan for your needs.
    </p>


  </div>
</section>
      
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
       
          
          <div className="row">
            <div className="col-lg-3">
              <div className="card">
                <div className="card-header">
                  <h5>Categories</h5>
                </div>
                <div className="card-body">
                  <ul className="list-group">
                    <li 
                      className={`list-group-item ${activeCategory === 'all' ? 'active' : ''}`}
                      onClick={() => setActiveCategory('all')}
                      style={{ cursor: 'pointer' }}
                    >
                      All Categories
                    </li>
                    {categories.map(category => (
                      <li 
                        key={category}
                        className={`list-group-item ${activeCategory === category ? 'active' : ''}`}
                        onClick={() => setActiveCategory(category)}
                        style={{ cursor: 'pointer' }}
                      >
                        {category}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="col-lg-9">
              {loading ? (
                <div className="text-center">
                  <Spin size="large" />
                </div>
              ) : (
                <Collapse accordion>
                  {filteredFaqs.map(faq => (
                    <Panel header={faq.question} key={faq.id}>
                      <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </Panel>
                  ))}
                </Collapse>
              )}
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Faq;